import { atom, selector, selectorFamily, waitForAll } from 'recoil';
import { polkaService, serviceData } from 'store/app';
import { transform2 } from 'utils/urlTypes';
import { expandKey, queryTypeToString } from 'utils/createOptions';
import valueToText from 'app/components/context/ValueToText';
import { addressState } from 'store/web3';
import { parseDataFromContract } from 'utils/common-function';
import { BigNumber } from 'bignumber.js';
import { zero } from 'constants/number';
import { amountFromWei } from 'utils/contract/common-function';
import { refreshManageLoanSelector } from 'app/pages/LoanDetail/store/manageLoan';
import _ from 'lodash';
import { merge } from 'utils/helpers';

export const getType = (api, pallet: string, method: string) => {
  const trans = transform2(api, pallet)(method);
  const key = expandKey(api, trans);
  const type = queryTypeToString(api.registry, key.key);
  return type;
};

interface ITokenDetail {
  name: string;

  [X: string]: any;
}

export const DEFAULT_EXCHANGE_RATE = '100000000000000000';

export const tokenDetail = selectorFamily<ITokenDetail, string | undefined>({
  key: 'tokenDetail',
  get:
    tokenId =>
    async ({ get }) => {
      console.log('tokenId', tokenId);
      get(refreshManageLoanSelector);
      // const { api } = get(polkaService) ?? {};
      const [t] = get(waitForAll([polkaService])) as any;
      const { api } = t;
      // if (!api) {
      //   return;
      // }
      const price = await api.query.assetRegistry.assets(tokenId);
      const typePrice = getType(api, 'assetRegistry', 'assets');
      const resPrice = valueToText(typePrice, price);

      //console.log('resPrice', resPrice)
      return resPrice;
    },
});

export const pricesSelector = selectorFamily({
  key: 'pricesSelector',
  get:
    tokenId =>
    async ({ get }) => {
      try {
        get(refreshManageLoanSelector);
        // const { api } = get(polkaService) ?? {};
        const [t] = get(waitForAll([polkaService])) as any;
        const { api } = t;
        if (!api) {
          return;
        }
        const price = await api.query.prices.lockedPrice(tokenId);
        const typePrice = getType(api, 'prices', 'lockedPrice');
        const resPrice = valueToText(typePrice, price);

        console.log('resPrice', resPrice);
        return resPrice;
      } catch (err) {}
    },
});

interface ICoinData {
  interestRatePerSec: BigNumber | null;
  liquidationPenalty?: BigNumber | string;
  liquidationRatio: BigNumber | string;
  maximumTotalDebitValue: BigNumber | string;
  requiredCollateralRatio?: BigNumber | string;
  tokenId: string;
}

export const debitExchangeRateSelector = selectorFamily({
  key: 'debitExchangeRateSelector',
  get:
    tokenId =>
    async ({ get }) => {
      const { api } = get(polkaService) as any;
      const debitExchangeRateQuery =
        await api.query.cdpEngine.debitExchangeRate(tokenId);
      const debitExchangeRateType = getType(
        api,
        'cdpEngine',
        'debitExchangeRate',
      );
      const debitExchangeRate = valueToText(
        debitExchangeRateType,
        debitExchangeRateQuery,
      );

      return { tokenId, debitExchangeRate };
    },
});

export const listCoinSelector = selectorFamily<ICoinData[], string | undefined>(
  {
    key: 'listCoinSelector',
    get:
      tokenId =>
      async ({ get }) => {
        get(refreshManageLoanSelector);
        // try {
        //   const { api } = get(polkaService) ?? {};
        const [t, service] = get(
          waitForAll([polkaService, serviceData]),
        ) as any;
        const { api } = t;
        if (!api) {
          return [
            {
              interestRatePerSec: undefined,
              liquidationPenalty: undefined,
              liquidationRatio: '0',
              maximumTotalDebitValue: '0',
              requiredCollateralRatio: undefined,
              tokenId: '0',
            },
          ];
        }
        // @ts-ignore
        if (tokenId) {
          const entries = await api.query.cdpEngine.collateralParams(tokenId);
          const type = getType(api, 'cdpEngine', 'collateralParams');
          const res = valueToText(type, entries);

          const debitExchangeRateQuery =
            await api.query.cdpEngine.debitExchangeRate(tokenId);
          const debitExchangeRateType = getType(
            api,
            'cdpEngine',
            'debitExchangeRate',
          );
          const debitExchangeRate = valueToText(
            debitExchangeRateType,
            debitExchangeRateQuery,
          );

          const totalDebit = get(totalDebtByTokenId(tokenId));

          res.totalDebit = totalDebit;
          res.tokenId = tokenId;
          res.exchangeRate =
            debitExchangeRate !== '<none>'
              ? debitExchangeRate
              : service.defaultExchangeRate ?? DEFAULT_EXCHANGE_RATE;
          console.log('totalDebit1', totalDebit);
          return [res];
        }
        const entries = await api.query.cdpEngine.collateralParams.entries();
        const type = getType(api, 'cdpEngine', 'collateralParams');
        const res = valueToText(type, entries);

        const revertRes = res.reduce(
          (acc, curr) => [...acc, { tokenId: curr[0][0], ...curr[1] }],
          [],
        );
        //console.log('revertRes', revertRes)
        return revertRes;
        // } catch (err) {
        //   //console.log(err.message)
        //   return [
        //     {
        //       interestRatePerSec: undefined,
        //       liquidationPenalty: undefined,
        //       liquidationRatio: '0',
        //       maximumTotalDebitValue: '0',
        //       requiredCollateralRatio: undefined,
        //       tokenId: '0',
        //     },
        //   ];
        // }
      },
  },
);

interface BalanceProp {
  free: BigNumber;
  frozen: BigNumber;
  reserved: BigNumber;
}

export const balanceSelector = selectorFamily<BalanceProp, string | undefined>({
  key: 'balanceSelector',
  get:
    tokenId =>
    async ({ get }) => {
      get(refreshManageLoanSelector);
      // try {
      const [address, t] = get(waitForAll([addressState, polkaService]));
      // const [t] = get(waitForAll([polkaService])) as any;
      const { api } = t as any;

      console.log('api', api);

      console.log('addr', { address, tokenId });

      if (!address || !tokenId) {
        return {
          free: zero,
          frozen: zero,
          reserved: zero,
        };
      }

      const balance = await api.query.tokens.accounts(address, tokenId);
      //console.log(balance)
      const type = getType(api, 'tokens', 'accounts');
      const res = valueToText(type, balance);
      console.log(res);
      const parse = parseDataFromContract(res) as BalanceProp;
      return {
        free: amountFromWei(new BigNumber(parse.free), 18),
        frozen: new BigNumber(parse.frozen),
        reserved: new BigNumber(parse.reserved),
      };
      // } catch (err) {
      //   console.log('balance err', err)
      //   return {
      //     free: zero,
      //     frozen: zero,
      //     reserved: zero,
      //   };
      // }
    },
});

export const totalDebtByTokenId = selectorFamily({
  key: 'totalDebtByTokenId',
  get:
    tokenId =>
    async ({ get }) => {
      const { api } = get(polkaService) as any;
      const res = await api.query.loans.totalPositions(tokenId);
      const type = getType(api, 'loans', 'totalPositions');
      const total = valueToText(type, res);
      console.log(total);
      return { tokenId, ...total };
    },
});

export const totalDebtSelector = selector({
  key: 'totalDebtSelector',
  get: async ({ get }) => {
    const { assetArray, defaultExchangeRate } = get(serviceData) as any;
    if (!assetArray) {
      return [];
    }
    const data = await Promise.all(
      assetArray.map(async item => get(totalDebtByTokenId(item.tokenId))),
    );

    const debitExchangeArr = await Promise.all(
      assetArray.map(async item =>
        get(debitExchangeRateSelector(item.tokenId)),
      ),
    );
    console.log('data', data);
    const t = merge(data, debitExchangeArr, 'tokenId') as any;

    return t.map(item => ({
      tokenId: item.tokenId,
      collateral: amountFromWei(new BigNumber(item.collateral), 18),
      debit: amountFromWei(new BigNumber(item.debit), 18),
      debitExchangeRate:
        item.debitExchangeRate === '<none>'
          ? amountFromWei(new BigNumber(defaultExchangeRate), 18)
          : amountFromWei(new BigNumber(item.debitExchangeRate), 18),
    }));
  },
});

export const refreshInitDataSelector = atom<number>({
  key: 'refreshInitDataSelector',
  default: 0,
});

export const initDataSelector = selectorFamily({
  key: 'initDataSelector',
  get:
    tokenId =>
    async ({ get }) => {
      get(refreshManageLoanSelector);
      // try {
      // const [token, price, tokenInfo] = await Promise.all([
      //   get(tokenDetail(tokenId as string)),
      //   get(pricesSelector(tokenId)),
      //   get(listCoinSelector(tokenId as string))
      // ]);

      const [token, price, tokenInfo] = get(
        waitForAll([
          tokenDetail(tokenId as string),
          pricesSelector(tokenId),
          listCoinSelector(tokenId as string),
        ]),
      );

      // console.log('testtt', t)

      console.log('[token, price, tokenInfo]', { token, price, tokenInfo });

      return { token: token?.name, price, ...tokenInfo[0] };
      // } catch (err) {
      //   console.log('eerr.', err)
      // }
    },
});
